import createEntityBundle from '~/src/Lib/createEntityBundle'
import { HarvestBatch as schema } from '~/src/Store/Schemas'

export default createEntityBundle({
  name: 'harvestBatches',
  apiConfig: { schema },
  // scope,
})
